import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"eraser\"><g id=\"icon\"><path id=\"Vector\" d=\"M7.52239 20.0821L3.67164 16.2313C2.77612 15.3358 2.77612 13.9925 3.67164 13.1866L12.2687 4.58955C13.1642 3.69403 14.5075 3.69403 15.3134 4.58955L20.3284 9.60448C21.2239 10.5 21.2239 11.8433 20.3284 12.6493L12.8955 20.0821\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M20.9553 20.0821H7.52246\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_3\" d=\"M5.73145 11.1269L13.7911 19.1866\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }